import { cva, cx, VariantProps } from "cva";
import React from "react";

import * as styles from "./Icon.module.css";
import { AccountIcon } from "./Paths/AccountIcon";
import { AccountOval2Icon } from "./Paths/AccountOval2Icon";
import { AccountOvalIcon } from "./Paths/AccountOvalIcon";
import { AccountOvalLineIcon } from "./Paths/AccountOvalLineIcon";
import { AddAutoIcon } from "./Paths/AddAutoIcon";
import { AddIcon } from "./Paths/AddIcon";
import { AddOvalIcon } from "./Paths/AddOvalIcon";
import { AddOvalLineIcon } from "./Paths/AddOvalLineIcon";
import { AppearanceDarkIcon } from "./Paths/AppearanceDarkIcon";
import { AppearanceLightIcon } from "./Paths/AppearanceLightIcon";
import { AppLineAndroidIcon } from "./Paths/AppLineAndroidIcon";
import { AppLineIosIcon } from "./Paths/AppLineIosIcon";
import { AppSatsudoraIcon } from "./Paths/AppSatsudoraIcon";
import { ArrowBackBriefIcon } from "./Paths/ArrowBackBriefIcon";
import { ArrowBackIcon } from "./Paths/ArrowBackIcon";
import { ArrowDoubleLeftIcon } from "./Paths/ArrowDoubleLeftIcon";
import { ArrowDoubleRightIcon } from "./Paths/ArrowDoubleRightIcon";
import { ArrowDownwardIcon } from "./Paths/ArrowDownwardIcon";
import { ArrowFirstIcon } from "./Paths/ArrowFirstIcon";
import { ArrowForwardBriefIcon } from "./Paths/ArrowForwardBriefIcon";
import { ArrowForwardIcon } from "./Paths/ArrowForwardIcon";
import { ArrowLastIcon } from "./Paths/ArrowLastIcon";
import { ArrowUpwardIcon } from "./Paths/ArrowUpwardIcon";
import { Barcode2Icon } from "./Paths/Barcode2Icon";
import { BarcodeIcon } from "./Paths/BarcodeIcon";
import { BlockIcon } from "./Paths/BlockIcon";
import { BoardIcon } from "./Paths/BoardIcon";
import { CalendarCheckedIcon } from "./Paths/CalendarCheckedIcon";
import { CalendarIcon } from "./Paths/CalendarIcon";
import { CameraIcon } from "./Paths/CameraIcon";
import { CancelOvalIcon } from "./Paths/CancelOvalIcon";
import { CancelOvalLineIcon } from "./Paths/CancelOvalLineIcon";
import { CheckIcon } from "./Paths/CheckIcon";
import { CheckOvalIcon } from "./Paths/CheckOvalIcon";
import { CheckOvalLineIcon } from "./Paths/CheckOvalLineIcon";
import { ClinicIcon } from "./Paths/ClinicIcon";
import { ClinicLineIcon } from "./Paths/ClinicLineIcon";
import { ClockIcon } from "./Paths/ClockIcon";
import { CloseIcon } from "./Paths/CloseIcon";
import { CommentIcon } from "./Paths/CommentIcon";
import { CommentLineIcon } from "./Paths/CommentLineIcon";
import { CommentTextIcon } from "./Paths/CommentTextIcon";
import { CommentTextLineIcon } from "./Paths/CommentTextLineIcon";
import { CommentTypingIcon } from "./Paths/CommentTypingIcon";
import { CommentTypingLineIcon } from "./Paths/CommentTypingLineIcon";
import { ComplexionIcon } from "./Paths/ComplexionIcon";
import { CopyContentIcon } from "./Paths/CopyContentIcon";
import { CopyFileIcon } from "./Paths/CopyFileIcon";
import { CreditCardIcon } from "./Paths/CreditCardIcon";
import { Crowds1Icon } from "./Paths/Crowds1Icon";
import { Crowds2Icon } from "./Paths/Crowds2Icon";
import { Crowds3Icon } from "./Paths/Crowds3Icon";
import { DashboardIcon } from "./Paths/DashboardIcon";
import { DeleteIcon } from "./Paths/DeleteIcon";
import { DropdownIcon } from "./Paths/DropdownIcon";
import { DroprightIcon } from "./Paths/DroprightIcon";
import { DropupIcon } from "./Paths/DropupIcon";
import { DummyIcon } from "./Paths/DummyIcon";
import { EditIcon } from "./Paths/EditIcon";
import { EditQaIcon } from "./Paths/EditQaIcon";
import { ErrorIcon } from "./Paths/ErrorIcon";
import { ErrorLineIcon } from "./Paths/ErrorLineIcon";
import { FactCheckIcon } from "./Paths/FactCheckIcon";
import { FactCheckLineIcon } from "./Paths/FactCheckLineIcon";
import { FamilyIcon } from "./Paths/FamilyIcon";
import { FamilyLineIcon } from "./Paths/FamilyLineIcon";
import { FavoriteIcon } from "./Paths/FavoriteIcon";
import { FavoriteLineIcon } from "./Paths/FavoriteLineIcon";
import { FileAttachmentIcon } from "./Paths/FileAttachmentIcon";
import { FileCloudDownloadIcon } from "./Paths/FileCloudDownloadIcon";
import { FileCloudIcon } from "./Paths/FileCloudIcon";
import { FileCloudLineIcon } from "./Paths/FileCloudLineIcon";
import { FileCloudUploadIcon } from "./Paths/FileCloudUploadIcon";
import { FileImageIcon } from "./Paths/FileImageIcon";
import { FileNoteIcon } from "./Paths/FileNoteIcon";
import { FilePdfIcon } from "./Paths/FilePdfIcon";
import { FileZipIcon } from "./Paths/FileZipIcon";
import { FlagIcon } from "./Paths/FlagIcon";
import { HashtagIcon } from "./Paths/HashtagIcon";
import { HeadphoneIcon } from "./Paths/HeadphoneIcon";
import { HealthInsuranceCardIcon } from "./Paths/HealthInsuranceCardIcon";
import { HelpIcon } from "./Paths/HelpIcon";
import { HelpLineIcon } from "./Paths/HelpLineIcon";
import { Home2Icon } from "./Paths/Home2Icon";
import { HomeIcon } from "./Paths/HomeIcon";
import { HomeLineIcon } from "./Paths/HomeLineIcon";
import { HourglassTopIcon } from "./Paths/HourglassTopIcon";
import { InfoIcon } from "./Paths/InfoIcon";
import { InfoLineIcon } from "./Paths/InfoLineIcon";
import { KeyboardIcon } from "./Paths/KeyboardIcon";
import { LeaveRoomIcon } from "./Paths/LeaveRoomIcon";
import { LinkIcon } from "./Paths/LinkIcon";
import { LocalParkingIcon } from "./Paths/LocalParkingIcon";
import { LocalShippingIcon } from "./Paths/LocalShippingIcon";
import { LocalShippingLineIcon } from "./Paths/LocalShippingLineIcon";
import { LocationOnIcon } from "./Paths/LocationOnIcon";
import { LockIcon } from "./Paths/LockIcon";
import { LockOpenIcon } from "./Paths/LockOpenIcon";
import { LoginIcon } from "./Paths/LoginIcon";
import { LogoutIcon } from "./Paths/LogoutIcon";
import { MailIcon } from "./Paths/MailIcon";
import { MapIcon } from "./Paths/MapIcon";
import { MaximizeIcon } from "./Paths/MaximizeIcon";
import { MccmDuoAddMedicineIcon } from "./Paths/MccmDuoAddMedicineIcon";
import { MccmDuoEkusulinkIcon } from "./Paths/MccmDuoEkusulinkIcon";
import { MccmDuoFamilyIcon } from "./Paths/MccmDuoFamilyIcon";
import { MccmDuoFileCloudDownloadIcon } from "./Paths/MccmDuoFileCloudDownloadIcon";
import { MccmDuoMedicationGuidanceIcon } from "./Paths/MccmDuoMedicationGuidanceIcon";
import { MccmDuoNotebookOpenIcon } from "./Paths/MccmDuoNotebookOpenIcon";
import { MccmDuoPrescriptionIcon } from "./Paths/MccmDuoPrescriptionIcon";
import { MccmDuoStarOnIcon } from "./Paths/MccmDuoStarOnIcon";
import { MccmLineCloseIcon } from "./Paths/MccmLineCloseIcon";
import { MccmLineCommentIcon } from "./Paths/MccmLineCommentIcon";
import { MccmLineFactCheckIcon } from "./Paths/MccmLineFactCheckIcon";
import { MccmLineHomeIcon } from "./Paths/MccmLineHomeIcon";
import { MccmLineMenuIcon } from "./Paths/MccmLineMenuIcon";
import { MccmLineNotebookCloseIcon } from "./Paths/MccmLineNotebookCloseIcon";
import { MedicationGuidanceIcon } from "./Paths/MedicationGuidanceIcon";
import { MenuGridIcon } from "./Paths/MenuGridIcon";
import { MenuIcon } from "./Paths/MenuIcon";
import { MicIcon } from "./Paths/MicIcon";
import { MicNoneIcon } from "./Paths/MicNoneIcon";
import { MinimizeBottomRightIcon } from "./Paths/MinimizeBottomRightIcon";
import { MinimizeIcon } from "./Paths/MinimizeIcon";
import { MobileIcon } from "./Paths/MobileIcon";
import { MobileLineIcon } from "./Paths/MobileLineIcon";
import { MobilePaymentYenIcon } from "./Paths/MobilePaymentYenIcon";
import { MobileSendIcon } from "./Paths/MobileSendIcon";
import { MoreHorizIcon } from "./Paths/MoreHorizIcon";
import { MoreVertIcon } from "./Paths/MoreVertIcon";
import { NetworkAntennaIcon } from "./Paths/NetworkAntennaIcon";
import { NewBadgeIcon } from "./Paths/NewBadgeIcon";
import { NewIcon } from "./Paths/NewIcon";
import { NewOvalIcon } from "./Paths/NewOvalIcon";
import { NewReleasesIcon } from "./Paths/NewReleasesIcon";
import { NewReleasesLineIcon } from "./Paths/NewReleasesLineIcon";
import { NewSquareIcon } from "./Paths/NewSquareIcon";
import { NiceDownIcon } from "./Paths/NiceDownIcon";
import { NiceUpIcon } from "./Paths/NiceUpIcon";
import { Notebook2Icon } from "./Paths/Notebook2Icon";
import { NotebookCloseIcon } from "./Paths/NotebookCloseIcon";
import { NotebookCloseLineIcon } from "./Paths/NotebookCloseLineIcon";
import { NotebookOpenIcon } from "./Paths/NotebookOpenIcon";
import { NotificationIcon } from "./Paths/NotificationIcon";
import { NotificationLineIcon } from "./Paths/NotificationLineIcon";
import { NotificationOffIcon } from "./Paths/NotificationOffIcon";
import { OpenInNewIcon } from "./Paths/OpenInNewIcon";
import { PartiallySupportedIcon } from "./Paths/PartiallySupportedIcon";
import { PersonAddIcon } from "./Paths/PersonAddIcon";
import { PersonRemoveIcon } from "./Paths/PersonRemoveIcon";
import { PharmacistIcon } from "./Paths/PharmacistIcon";
import { PhoneIcon } from "./Paths/PhoneIcon";
import { PillIcon } from "./Paths/PillIcon";
import { PillLineIcon } from "./Paths/PillLineIcon";
import { PillOffIcon } from "./Paths/PillOffIcon";
import { PillsThreeIcon } from "./Paths/PillsThreeIcon";
import { PillsTwoIcon } from "./Paths/PillsTwoIcon";
import { PrescriptionIcon } from "./Paths/PrescriptionIcon";
import { PrintIcon } from "./Paths/PrintIcon";
import { PublicIcon } from "./Paths/PublicIcon";
import { QrcodeIcon } from "./Paths/QrcodeIcon";
import { ReceiptCheckedIcon } from "./Paths/ReceiptCheckedIcon";
import { ReceiptFastIcon } from "./Paths/ReceiptFastIcon";
import { ReceiptIcon } from "./Paths/ReceiptIcon";
import { ReferenceMarkIcon } from "./Paths/ReferenceMarkIcon";
import { RefreshIcon } from "./Paths/RefreshIcon";
import { RemoveIcon } from "./Paths/RemoveIcon";
import { ReplayIcon } from "./Paths/ReplayIcon";
import { RhombusIcon } from "./Paths/RhombusIcon";
import { RhombusLineIcon } from "./Paths/RhombusLineIcon";
import { ScaleIcon } from "./Paths/ScaleIcon";
import { ScancodeIcon } from "./Paths/ScancodeIcon";
import { SearchIcon } from "./Paths/SearchIcon";
import { SearchSeeIcon } from "./Paths/SearchSeeIcon";
import { SendIcon } from "./Paths/SendIcon";
import { SettingIcon } from "./Paths/SettingIcon";
import { SignalCellularIcon } from "./Paths/SignalCellularIcon";
import { SmsIcon } from "./Paths/SmsIcon";
import { SocialFacebookIcon } from "./Paths/SocialFacebookIcon";
import { SocialInstagramIcon } from "./Paths/SocialInstagramIcon";
import { SocialLineIcon } from "./Paths/SocialLineIcon";
import { SocialTwitterIcon } from "./Paths/SocialTwitterIcon";
import { SocialXIcon } from "./Paths/SocialXIcon";
import { SortIcon } from "./Paths/SortIcon";
import { StarHalfIcon } from "./Paths/StarHalfIcon";
import { StarOffIcon } from "./Paths/StarOffIcon";
import { StarOnIcon } from "./Paths/StarOnIcon";
import { StarsIcon } from "./Paths/StarsIcon";
import { StethoscopeIcon } from "./Paths/StethoscopeIcon";
import { StorefrontIcon } from "./Paths/StorefrontIcon";
import { StoreIcon } from "./Paths/StoreIcon";
import { SupportedBoldIcon } from "./Paths/SupportedBoldIcon";
import { SupportedIcon } from "./Paths/SupportedIcon";
import { TrainIcon } from "./Paths/TrainIcon";
import { TriangleBottomIcon } from "./Paths/TriangleBottomIcon";
import { TriangleBottomLineIcon } from "./Paths/TriangleBottomLineIcon";
import { TriangleLeftIcon } from "./Paths/TriangleLeftIcon";
import { TriangleLeftLineIcon } from "./Paths/TriangleLeftLineIcon";
import { TriangleRightIcon } from "./Paths/TriangleRightIcon";
import { TriangleRightLineIcon } from "./Paths/TriangleRightLineIcon";
import { TriangleTopIcon } from "./Paths/TriangleTopIcon";
import { TriangleTopLineIcon } from "./Paths/TriangleTopLineIcon";
import { VaccinationIcon } from "./Paths/VaccinationIcon";
import { VideoIcon } from "./Paths/VideoIcon";
import { VideoOffIcon } from "./Paths/VideoOffIcon";
import { ViewList2Icon } from "./Paths/ViewList2Icon";
import { ViewListIcon } from "./Paths/ViewListIcon";
import { ViewOffIcon } from "./Paths/ViewOffIcon";
import { ViewOnIcon } from "./Paths/ViewOnIcon";
import { WarningIcon } from "./Paths/WarningIcon";
import { WarningLineIcon } from "./Paths/WarningLineIcon";
import { YqbAppPharmacySilhouetteIcon } from "./Paths/YqbAppPharmacySilhouetteIcon";
import { YqbSilhouetteIcon } from "./Paths/YqbSilhouetteIcon";
import { ZoomInIcon } from "./Paths/ZoomInIcon";
import { ZoomOutIcon } from "./Paths/ZoomOutIcon";

export const variants = cva({
  variants: {
    color: {
      primary: styles.primary,
      secondary: styles.secondary,
      tertiary: styles.tertiary,
      "accent-primary": styles.accentPrimary,
      "accent-secondary": styles.accentSecondary,
      "accent-tertiary": styles.accentTertiary,
      key: styles.key,
      link: styles.link,
      notice: styles.notice,
      caution: styles.caution,
    },
    size: {
      xs: styles.sizeXs,
      s: styles.sizeS,
      m: styles.sizeM,
      xm: styles.sizeXm,
      xxm: styles.sizeXxm,
      l: styles.sizeL,
      xl: styles.sizeXl,
      xxl: styles.sizeXxl,
      "3xl": styles.size3xl,
      "4xl": styles.size4xl,
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const Icon = ({ fill = "inherit", children, color, size, className, ...props }: IconProps) => {
  return (
    <svg
      fill={fill}
      aria-hidden={true}
      className={cx(variants({ color, size }), className)}
      viewBox="0 0 24 24"
      {...props}
    >
      {children}
    </svg>
  );
};

export type IconProps = VariantProps<typeof variants> & React.SVGProps<SVGSVGElement> & { className?: string };

export {
  AccountIcon,
  AccountOval2Icon,
  AccountOvalIcon,
  AccountOvalLineIcon,
  AddAutoIcon,
  AddIcon,
  AddOvalIcon,
  AddOvalLineIcon,
  AppearanceDarkIcon,
  AppearanceLightIcon,
  AppLineAndroidIcon,
  AppLineIosIcon,
  AppSatsudoraIcon,
  ArrowBackBriefIcon,
  ArrowBackIcon,
  ArrowDoubleLeftIcon,
  ArrowDoubleRightIcon,
  ArrowDownwardIcon,
  ArrowFirstIcon,
  ArrowForwardBriefIcon,
  ArrowForwardIcon,
  ArrowLastIcon,
  ArrowUpwardIcon,
  Barcode2Icon,
  BarcodeIcon,
  BlockIcon,
  BoardIcon,
  CalendarCheckedIcon,
  CalendarIcon,
  CameraIcon,
  CancelOvalIcon,
  CancelOvalLineIcon,
  CheckIcon,
  CheckOvalIcon,
  CheckOvalLineIcon,
  ClinicIcon,
  ClinicLineIcon,
  ClockIcon,
  CloseIcon,
  CommentIcon,
  CommentLineIcon,
  CommentTextIcon,
  CommentTextLineIcon,
  CommentTypingIcon,
  CommentTypingLineIcon,
  ComplexionIcon,
  CopyContentIcon,
  CopyFileIcon,
  CreditCardIcon,
  Crowds1Icon,
  Crowds2Icon,
  Crowds3Icon,
  DashboardIcon,
  DeleteIcon,
  DropdownIcon,
  DroprightIcon,
  DropupIcon,
  DummyIcon,
  EditIcon,
  EditQaIcon,
  ErrorIcon,
  ErrorLineIcon,
  FactCheckIcon,
  FactCheckLineIcon,
  FamilyIcon,
  FamilyLineIcon,
  FavoriteIcon,
  FavoriteLineIcon,
  FileAttachmentIcon,
  FileCloudDownloadIcon,
  FileCloudIcon,
  FileCloudLineIcon,
  FileCloudUploadIcon,
  FileImageIcon,
  FileNoteIcon,
  FilePdfIcon,
  FileZipIcon,
  FlagIcon,
  HashtagIcon,
  HeadphoneIcon,
  HealthInsuranceCardIcon,
  HelpIcon,
  HelpLineIcon,
  Home2Icon,
  HomeIcon,
  HomeLineIcon,
  HourglassTopIcon,
  InfoIcon,
  InfoLineIcon,
  KeyboardIcon,
  LeaveRoomIcon,
  LinkIcon,
  LocalParkingIcon,
  LocalShippingIcon,
  LocalShippingLineIcon,
  LocationOnIcon,
  LockIcon,
  LockOpenIcon,
  LoginIcon,
  LogoutIcon,
  MailIcon,
  MapIcon,
  MaximizeIcon,
  MccmDuoAddMedicineIcon,
  MccmDuoEkusulinkIcon,
  MccmDuoFamilyIcon,
  MccmDuoFileCloudDownloadIcon,
  MccmDuoMedicationGuidanceIcon,
  MccmDuoNotebookOpenIcon,
  MccmDuoPrescriptionIcon,
  MccmDuoStarOnIcon,
  MccmLineCloseIcon,
  MccmLineCommentIcon,
  MccmLineFactCheckIcon,
  MccmLineHomeIcon,
  MccmLineMenuIcon,
  MccmLineNotebookCloseIcon,
  MedicationGuidanceIcon,
  MenuGridIcon,
  MenuIcon,
  MicIcon,
  MicNoneIcon,
  MinimizeBottomRightIcon,
  MinimizeIcon,
  MobileIcon,
  MobileLineIcon,
  MobilePaymentYenIcon,
  MobileSendIcon,
  MoreHorizIcon,
  MoreVertIcon,
  NetworkAntennaIcon,
  NewBadgeIcon,
  NewIcon,
  NewOvalIcon,
  NewReleasesIcon,
  NewReleasesLineIcon,
  NewSquareIcon,
  NiceDownIcon,
  NiceUpIcon,
  Notebook2Icon,
  NotebookCloseIcon,
  NotebookCloseLineIcon,
  NotebookOpenIcon,
  NotificationIcon,
  NotificationLineIcon,
  NotificationOffIcon,
  OpenInNewIcon,
  PartiallySupportedIcon,
  PersonAddIcon,
  PersonRemoveIcon,
  PharmacistIcon,
  PhoneIcon,
  PillIcon,
  PillLineIcon,
  PillOffIcon,
  PillsThreeIcon,
  PillsTwoIcon,
  PrescriptionIcon,
  PrintIcon,
  PublicIcon,
  QrcodeIcon,
  ReceiptCheckedIcon,
  ReceiptFastIcon,
  ReceiptIcon,
  ReferenceMarkIcon,
  RefreshIcon,
  RemoveIcon,
  ReplayIcon,
  RhombusIcon,
  RhombusLineIcon,
  ScaleIcon,
  ScancodeIcon,
  SearchIcon,
  SearchSeeIcon,
  SendIcon,
  SettingIcon,
  SignalCellularIcon,
  SmsIcon,
  SocialFacebookIcon,
  SocialInstagramIcon,
  SocialLineIcon,
  SocialTwitterIcon,
  SocialXIcon,
  SortIcon,
  StarHalfIcon,
  StarOffIcon,
  StarOnIcon,
  StarsIcon,
  StethoscopeIcon,
  StorefrontIcon,
  StoreIcon,
  SupportedBoldIcon,
  SupportedIcon,
  TrainIcon,
  TriangleBottomIcon,
  TriangleBottomLineIcon,
  TriangleLeftIcon,
  TriangleLeftLineIcon,
  TriangleRightIcon,
  TriangleRightLineIcon,
  TriangleTopIcon,
  TriangleTopLineIcon,
  VaccinationIcon,
  VideoIcon,
  VideoOffIcon,
  ViewList2Icon,
  ViewListIcon,
  ViewOffIcon,
  ViewOnIcon,
  WarningIcon,
  WarningLineIcon,
  YqbAppPharmacySilhouetteIcon,
  YqbSilhouetteIcon,
  ZoomInIcon,
  ZoomOutIcon,
};
